import { render } from "./SuratMasuk.vue?vue&type=template&id=488d70f6&scoped=true"
import script from "./SuratMasuk.vue?vue&type=script&lang=js"
export * from "./SuratMasuk.vue?vue&type=script&lang=js"

import "./SuratMasuk.vue?vue&type=style&index=0&id=488d70f6&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488d70f6"]])

export default __exports__